export default __webpack_public_path__ + "media/images/features/local_delivery/episode4/LP_03-fe87e154146e8829baec0445a14ccceb.jpg";